// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"a022b92c","308":"574a7188","392":"dc067963","453":"03346f77","530":"a054e353","571":"9317ff91","645":"fab1be6f","660":"0b093645","963":"7b1fceec"}[chunkId] + ".chunk.js";
};